/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TourCardCategoryApiModel } from './tour-card-category';

export interface TourCardServiceApiModel {
  /**
   * Available sevice account amount
   */
  available_amount?: number | null;
  /**
   * Service availability flag
   */
  available_now?: number;
  /**
   * Number of times available for use
   */
  available_times?: number;
  category?: TourCardCategoryApiModel;
  /**
   * Decrement step of account amount
   */
  decrement_step?: number;
  /**
   * Service ID
   */
  id?: string;
  /**
   * URL of object image
   */
  image?: string;
  /**
   * Public description
   */
  public_description?: string;
  /**
   * Public title
   */
  public_title?: string;
  /**
   * Usage limit per loyalty
   */
  usage_limit_per_loyalty?: number;
  /**
   * Usage limit per loyalty period type
   */
  usage_limit_per_loyalty_period_type?: TourCardServiceApiModelUsageLimitPerLoyaltyPeriodTypeEnum;
  /**
   * Usage limit per loyalty period value
   */
  usage_limit_per_loyalty_period_value?: number;
  /**
   * Usage limit per POS
   */
  usage_limit_per_pos?: number;
  /**
   * Usage limit per POS period type
   */
  usage_limit_per_pos_period_type?: TourCardServiceApiModelUsageLimitPerPosPeriodTypeEnum;
  /**
   * Usage limit per POS period value
   */
  usage_limit_per_pos_period_value?: number;
  /**
   * Number of service usage by customer
   */
  used_times?: number;
}
export enum TourCardServiceApiModelUsageLimitPerLoyaltyPeriodTypeEnum {
  AllCardTime = 'all-card-time',
  Hour = 'hour',
  Day = 'day',
  Month = 'month'
}
export enum TourCardServiceApiModelUsageLimitPerPosPeriodTypeEnum {
  AllCardTime = 'all-card-time',
  Hour = 'hour',
  Day = 'day',
  Month = 'month'
}
